export interface UserMeModel {
  first_name?: string;
  last_name?: string;
  expired_at?: number;
  phone: string
  role: UserMeModel.RoleEnum;
}

export namespace UserMeModel {
  export type RoleEnum = 'admin' | 'user' | 'operator' | 'technical_operator' | 'TechnicalSupport' | 'guest';
  export const RoleEnum = {
    ADMIN: 'admin' as RoleEnum,
    USER: 'user' as RoleEnum,
    OPERATOR: 'operator' as RoleEnum,
    TECHNICAL_OPERATOR: 'technical_operator' as RoleEnum,
    TECHNICAL_SUPPORT: 'TechnicalSupport' as RoleEnum,
    GUEST: 'guest' as RoleEnum
  };
}
